import SvgLoader from "../svg/SvgLoader";
import React from "react";

export default function Button(props: { text: string, className?: string, loading?: boolean, padding?: "compact" | "none", onClick?: React.MouseEventHandler<HTMLButtonElement>, disabled?: boolean, children?: React.ReactNode}) {
    return <button onClick={props.onClick} disabled={props.loading || props.disabled}
                className={`${props.className} ${(props.padding ? (props.padding === "compact" ? "p-2" : "") : "px-4 py-2")} text-white hover:brightness-90 rounded-lg disabled:bg-neutral-600 flex items-center`}>
            {props.loading ? <SvgLoader className="size-5 text-transparent fill-white text-neutral-700 animate-spin inline"/> : props.children ?? props.text}
    </button>
}